// test705
(705 && 0);
